import { AppointmentOutcomePaymentDetails } from '@/shared/appointments/appointment-outcome-payment-details';
import { AppointmentOutcomeProduct } from '@/shared/appointments/appointment-outcome-product';
import { InstructionType } from '@/shared/instruction-type';

export interface AppointmentOutcome {
    id?: string | null;
    appointmentId: string | null;
    outcomeTypeId: string | null;
    instructionType: InstructionType | null;
    cancellationTypeId: string | null;
    noInstructionTypeId: string | null;
    noInstructionNotes: string | null;
    estimatedEstateValue: string | null;
    executorTypeId: string | null;
    callbackDate: string | Date | null;
    notes: string | null;
    isLegacy: boolean;
    paymentDetails: AppointmentOutcomePaymentDetails | null;
    products: Array<AppointmentOutcomeProduct>;
    version: number | null;
}

export function createAppointmentOutcome(appointmentId: string | null): AppointmentOutcome {
    return {
        appointmentId,
        outcomeTypeId: null,
        instructionType: null,
        cancellationTypeId: null,
        noInstructionTypeId: null,
        noInstructionNotes: null,
        estimatedEstateValue: null,
        executorTypeId: null,
        callbackDate: null,
        notes: null,
        isLegacy: false,
        paymentDetails: null,
        products: new Array<AppointmentOutcomeProduct>(),
        version: null,
    };
}
